import SalesBusinessReportTable from "./SalesBusinessReportTable";
import SalesReportTable from "./SalesReportTable";

const SalesReportData = ({ salesReportData }) => {
    let _salesTrainingReport = salesReportData?.salesTrainingReport
    
    let _salesBusinessChurnClosingReport = salesReportData?.salesBusinessChurnClosingReport || []
    let _salesBusinessReport = salesReportData?.salesBusinessReport || []
    let _reportData = [..._salesBusinessReport, ..._salesBusinessChurnClosingReport]

    return(
        <div className="flex flex-col text-black">
            <div className="flex flex-col text-black w-full mx-auto">
                <p className="font-bold my-0 py-0">Sales Business Report</p>
                <SalesBusinessReportTable salesReportData={_reportData} />
            </div>
            {_salesTrainingReport?.length > 0 &&
                <div className="flex flex-col text-black w-full mx-auto">
                    <p className="font-bold my-0 py-0">Sales Training</p>
                    <SalesReportTable salesReportData={_salesTrainingReport} />
                </div>
            }
        </div>
    )
}

export default SalesReportData